import request from '@/utils/request'

export function track (no, status) {
  return request({
    url: '/api/v1/com/changeStatus',
    method: 'get',
    params: { no, status }
  })
}
